/**
 * 
 * PasswordField
 * 
 **/

 import React ,{ useState}  from 'react'
 import PropTypes from 'prop-types'
 import { Label, Input, FormGroup } from 'reactstrap'
 
 
 function PasswordField (props) {
         const { label, name, value, placeholder, onChange, isInvalid, required, style, disabled, labelClass } = props
        
    const [passwordFlag, setpasswordFlag] = useState(true)
         return (
             <React.Fragment>
                 <FormGroup className='no-margin'>
                     <Label className={labelClass} htmlFor={name}>{label} {required ? <span style={{color: 'red'}}>*</span> : null}</Label>
                     <Input
                         type={passwordFlag?"password":"text"}
                         className="form-control"
                         name={name}
                         value={value}
                         onChange={onChange}
                         id={name}
                         style={style}
                         disabled={disabled}
                         placeholder={placeholder}
                         invalid={isInvalid ? true : false}
                         
                     >
                         
                     </Input>
                     <a
                        style={{    position: "relative",
                            left: "91%",
                            display: "inline-block !IMPORTANT",
                            "text-align": "right",
                            top: "-27PX", height: '46px' }}
                        className="floatRight"
                        onClick={() => setpasswordFlag(!passwordFlag)}>
                        <i  className="dripicons-preview"    ></i>
                    </a>
                 </FormGroup>
             </React.Fragment>
         )
 }
 
 PasswordField.propTypes = {
     t: PropTypes.any,
     label: PropTypes.string,
     value: PropTypes.string,
     name: PropTypes.string,
     onChange: PropTypes.func,
     placeholder: PropTypes.string,
     isInvalid: PropTypes.any,
     required: PropTypes.bool,
     style: PropTypes.object,
     disabled: PropTypes.any,
     labelClass: PropTypes.any
 }
 
 export default PasswordField